import { ComponentPropsWithoutRef, createElement } from "react";
import { BlockAttachmentsContextProvider } from "../scenes/note-fill-in/contexts/BlockAttachmentsContext";
import { NOTES_TYPES, TNotesType } from "../types";

type Props = Omit<
  ComponentPropsWithoutRef<typeof BlockAttachmentsContextProvider>,
  "children"
>;

/**
 * render component w/ attachments data provider
 */
const withBlockAttachments = (
  type: TNotesType,
  Wrapped: JSX.Element,
  attachmentsContextProviderProps: Props,
) =>
  type === NOTES_TYPES.note ? (
    <BlockAttachmentsContextProvider {...attachmentsContextProviderProps}>
      {createElement(Wrapped.type, Wrapped.props)}
    </BlockAttachmentsContextProvider>
  ) : (
    createElement(Wrapped.type, Wrapped.props)
  );

export default withBlockAttachments;
